<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
      Newsletery i Mailingi - lista
    </h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="pt-4 block text-gray-700">Data wysyłki:</label>
        <text-input v-model="form.sent_at" class="mt-1 w-full" type="date" />
      </search-filter>
      
      <inertia-link class="btn-shtax" :href="route('mailbox.mailings.create')" v-if="$page.props.can['add mailings']">
        <span>Nowy</span>
        <span class="hidden md:inline">newsleter</span>
      </inertia-link>
      
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-3 pb-4">#</th>
          <th class="px-3 pt-3 pb-4">Tytuł</th>
          <th class="px-3 pt-3 pb-4">Status</th>
          <th class="px-3 pt-3 pb-4">Dodał</th>
          <th class="px-3 pt-3 pb-4">Data dodania</th>
          <th class="px-3 pt-3 pb-4" colspan="2">Podgląd</th>
        </tr>
        <tr v-for="mailing in mailings.data" :key="mailing.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.mailings.edit', {'mailing':mailing.id})">
              {{ mailing.id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.mailings.edit', {'mailing':mailing.id})">
              {{ mailing.title }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.mailings.edit', {'mailing':mailing.id})">
              {{ mailing.status }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.mailings.edit', {'mailing':mailing.id})">
              {{ mailing.user }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.mailings.edit', {'mailing':mailing.id})">
              {{ mailing.created_at }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.mailings.preview', {'mailing':mailing.id})">
              <fa icon="eye" size="lg" fixed-width />
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.mailings.edit', {'mailing':mailing.id})">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="mailings.data.length === 0">
          <td class="border-t px-3 py-2" colspan="6">Brak newsletterów.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-3" :links="mailings.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Newsletery i Mailingi' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    MultiselectInput,
    TextInput
  },
  layout: Layout,
  props: {
    mailings: Object,
    filters: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        created_at: this.filters.created_at
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('mailbox.mailings'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },

  // mounted() {
  //   console.log(this.notifications)
  // }

}
</script>
